module.exports = __webpack_public_path__ + "static2023-4-17/img/recent.ba2edbe2.png";